const userProfileActions = {
  SET_USER_INFO: "SET_USER_INFO",
  setUserInfo: (userInfo) => ({
    type: userProfileActions.SET_USER_INFO,
    userInfo,
  }),
};

export default userProfileActions;
